/**
 * "Link to task…" from a commit (commit ↔ task links, slice 2 — the reverse
 * direction): the task's board is read, the link added to the task's
 * `commitLinks` (taskCommitLinks.js) and only that change written
 * (writeBoardChanges + diffBoards, the field-level save the open board uses),
 * then the boards are bumped so an open board re-reads it.
 */
import { diffBoards, readBoard, writeBoardChanges } from '../../extensions/bundled/task-manager/boardsStore';
import { bumpBoards } from '../../extensions/bundled/task-manager/boardsUiStore';
import { withCommitLinked } from '../../extensions/bundled/task-manager/taskCommitLinks';

/** Every task of `boardIds` with its key, for the task picker. */
export async function tasksOfBoards(boardIds, { keysFor }) {
  const out = [];
  for (const id of boardIds || []) {
    // eslint-disable-next-line no-await-in-loop
    const board = await readBoard(id).catch(() => null);
    if (!board) continue;
    const keys = keysFor(board);
    for (const task of board.tasks || []) {
      out.push({ boardId: board.id, boardName: board.name || '', taskId: task.id, title: task.title || '', key: keys.get(String(task.id)) || null, done: !!task.done });
    }
  }
  return out;
}

/** Link `commit` to task `taskId` on board `boardId`. Resolves to false when the task is gone. */
export async function linkCommitToTask({ boardId, taskId, commit, userId = null }) {
  const board = await readBoard(boardId);
  const task = board?.tasks?.find((t) => String(t.id) === String(taskId));
  if (!task) return false;
  const next = {
    ...board,
    tasks: board.tasks.map((t) => (t === task ? { ...t, commitLinks: withCommitLinked(t, commit, { userId }), updatedAt: new Date().toISOString() } : t)),
  };
  await writeBoardChanges(next, diffBoards(board, next));
  bumpBoards();
  return true;
}
